import React from 'react';
import './AIPoweredTools.css';

const AIPoweredTools = () => {
  return (
    <div className="ai-container">
      <div className="ai-hero">
        <h1 className="ai-title">AI-Powered Tools</h1>
        <p className="ai-subtitle">
          Unlock the power of automation and intelligence with custom AI tools — from chatbots and recommendation engines to advanced analytics and generative design.
        </p>
      </div>

      <div className="ai-features">
        <div className="feature-card">
          <h3>ChatGPT Integrations</h3>
          <p>Enhance user experiences with ChatGPT-based assistants, support bots, and conversational interfaces.</p>
        </div>
        <div className="feature-card">
          <h3>Recommendation Systems</h3>
          <p>Drive engagement and sales with personalized content, product suggestions, and data-driven logic.</p>
        </div>
        <div className="feature-card">
          <h3>AI Data Automation</h3>
          <p>Automate data cleaning, extraction, and reporting using AI workflows — saving hours of manual work.</p>
        </div>
        <div className="feature-card">
          <h3>Custom AI APIs</h3>
          <p>We build and integrate APIs for image analysis, voice-to-text, text summarization, and more.</p>
        </div>
      </div>

      <div className="ai-cta">
        <h2>Need a Smart Tool for Your Business?</h2>
        <p>Let AI work for you — generate a project quotation and we’ll handle the intelligence.</p>
        <button onClick={() => window.open('/project_prompt', '_blank')}>
          Generate Quotation
        </button>
      </div>
    </div>
  );
};

export default AIPoweredTools;
